Core.ProductDetail = {
    init: function () {
        var _config = Core.Config.ProductDetail.Gallery;
        Core.ProductDetail.Cache = {
            $mainImg: $('#main-img'),
            $galleryThumbs: $('#gallery-thumnbs'),
            $productZoom: $('#product-zoom'),
            $rentalForm: $('#rental-form'),
            $trialForm: $('#trial-form'),
            $variants: $('#variants'),
            $variantSelections: $('#variantSelections'),
            $trialButton: $('.trial'),
            $rentButton: $('.rent'),
            $confirmationWindow: $('#confirmation-notification'),
            $addToQuoteButton: $('.addToQuote'),
            $scrollToTabs: $('.tab-check'),
            $favouriteBtn: $('#add-to-favourites'),
            $selectedVariantTitle: $('.product-details__variant--title'),
            $selectedVariantPrice: $('.product-details__variant--price span.price'),
            $selectedVariantListPrice: $('.product-details__variant--price span.was-price'),
            $selectedVariantCartBtn: $('.product-details__variant--cart'),
            $selectedVariantCompareBtn: $('.product-details__variant--compare'),
            $productTitle: '',
            $productPrice: '',
            $productListPrice: '',
            gallerySettings: {
                slideMargin: Core.Config.ProductDetail.Gallery.SlideMargin,
                slideWidth: _config.SlideWidth,
                minSlides: _config.MinSlides,
                maxSlides: _config.MaxSlides,
                moveSlides: _config.MoveSlides,
                auto: _config.Auto,
                speed: _config.Speed,
                pager: _config.Pager,
                infiniteLoop: _config.InfiniteLoop,
                hideControlOnEnd: _config.HideControlOnEnd,
                useCSS: _config.UseCSS
            },
        };

        $('.datepicker').kendoDatePicker({
            format: "dd/MM/yyyy"
        });

        //product variant display
        if (this.Cache.$variants.length > 0) {
            this.variants.init();
        }

        //product variant selction display
        if (this.Cache.$variantSelections.length > 0) {
            this.variantSelection.init();
        }

        //image & 360 gallery
        Core.ProductDetail.Cache.$galleryThumbs.imagesLoaded(function() {
            Core.ProductDetail.gallery.init();
        });

        //trial
        this.trial();

        //rent
        this.rent();

        //scroll links to tabs
        this.scrollToTabs();

        //add|remove favourite
        this.favourites();
        this.viewMore();

        this.arrangeLayout();
        // this.setProductDetailHeight();
        var stockIntegration = new Core.StockIntegration('pdp');
        stockIntegration.init();

        var resizeTimer;
        $(window).on('resize', function (e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                Core.ProductDetail.arrangeLayout();
                // Core.ProductDetail.setProductDetailHeight();
            }, 100);
        });

    },
    variants: {
        init: function () {

            var _$groupPrice = $('#groupPrice');

            function updateVariantQuantity() {

                if (this.value() === null) {
                    this.value(1);
                }

                var _sku = $(this.element).data('id'),
                    _qty = this.value(),
                    _groupPrice = 0;

                for (var i = 0; i < window.selectedVariants.length; i++) {
                    if (window.selectedVariants[i]['sku'] == _sku) {
                        window.selectedVariants[i].qty = _qty;
                        break;
                    }
                }

                for (var x = 0; x < selectedVariants.length; x++) {
                    _groupPrice += parseFloat(selectedVariants[x].price * selectedVariants[x].qty);
                }

                if (_groupPrice === 0) {
                    _$groupPrice.text(Core.Config.POA.Text).show();
                }
                else {
                    _$groupPrice.text('$' + _groupPrice.toFixed(2)).show();
                }

            }

            if($('.product-details__variant--qty').length) {
                $('.product-details__variant--qty').kendoNumericTextBox({
                    format: "#",
                    step: 1,
                    change: updateVariantQuantity,
                    spin: updateVariantQuantity
                });
            }

            $('.related-products__accordion-tab').on('click', function () {
                var _$this = $(this);
                _$this.children('span').toggleClass('icon-plus-grey').toggleClass('icon-minus-grey');
                _$this.siblings('.related-products__accordion-content').slideToggle();
            });

            $('.related-products').each(function () {
                var _$firstAccordion = $(this).find('.related-products__accordion').first().children().first();
                _$firstAccordion.children().first().trigger('click');
                _$firstAccordion.find('ul').children().first().find('.related-products__accordion-tab').trigger('click');
            });
        }
    },
    variantSelection: {
        init: function () {
            var _$groupPrice = $('#groupPrice');
            window.selectedSkus = [];
            var selectionColour = $('#selection_colour').find('img');
            selectionColour.on('click', $.proxy(this.filter, this));
            selectionColour.on('click', function () {
                var _$this = $(this);
                if (_$this.closest('ul').hasClass('disabled')) {
                } else {
                    $('img.selected').removeClass('selected');
                    $(this).addClass('selected');
                }
            });

            $('.product-details__selection').find('select').on('change', $.proxy(this.filter, this));

            function updateVariantQuantity() {

                if (this.value() === null) {
                    this.value(1);
                }

                var _sku = window.selectedSkus[0].Code,
                    _qty = this.value(),
                    _groupPrice = 0;

                for (var i = 0; i < window.selectedVariants.length; i++) {
                    if (window.selectedVariants[i]['sku'] == _sku) {
                        window.selectedVariants[i].qty = _qty;
                        break;
                    }
                }

                for (var x = 0; x < selectedVariants.length; x++) {
                    _groupPrice += parseFloat(selectedVariants[x].price * selectedVariants[x].qty);
                }

                if (_groupPrice === 0) {
                    _$groupPrice.text(Core.Config.POA.Text).show();
                }
                else {
                    _$groupPrice.text('$' + _groupPrice.toFixed(2)).show();
                }
            }

            var _$selectionQuantity = $('#selection_qty');

            //init quantity input
            if(_$selectionQuantity.length) {
                _$selectionQuantity.kendoNumericTextBox({
                    format: "#",
                    step: 1,
                    change: updateVariantQuantity,
                    spin: updateVariantQuantity
                });

                this.numerictextbox = _$selectionQuantity.data("kendoNumericTextBox");
                this.numerictextbox.enable(false);
            }

            Core.ProductDetail.Cache.$productTitle = Core.ProductDetail.Cache.$selectedVariantTitle.html();
            Core.ProductDetail.Cache.$productPrice = Core.ProductDetail.Cache.$selectedVariantPrice.text();
            Core.ProductDetail.Cache.$productListPrice = Core.ProductDetail.Cache.$selectedVariantListPrice.text();
        },
        renderProductDetail: function(data) {
            var $complexVar = $('#complexVariant');
            var isWholesale = Core.Util.isWholesale();
            data.IsDVA =  Core.ProductDetail.isDVA();

            if($complexVar.hasClass('is-portalsite')) {
                var template = isWholesale ? 
                    kendo.template($("#productDetailVariantWholesaleTemplate").html()) :
                    kendo.template($("#productDetailVariantTemplate").html());                
                
                var render = template(data);
                $complexVar.html(render);

                $('#complexVariant .product-details__variant--qty').kendoNumericTextBox({
                    format: "#",
                    step: 1,
                    change: Core.ProductDetail.updateVariantQuantity,
                    spin: Core.ProductDetail.updateVariantQuantity
                });

                if (!!$('#product-detail').data('check-local-stock-api')) {
                    var stockIntegration = new Core.StockIntegration('pdp');
                    stockIntegration.checkStockAsyncPdp(true);

                    /*
                    $complexVar.find('.stock-checkBtn').on('click', function () {
                        var $btn = $(this);                        
                        stockIntegration.updateStock(false, $btn.closest('.product-details__variant'));
                    });
                    $complexVar.find('.stock-changeSuburbBtn').on('click', function () {
                        var $btn = $(this);
                        stockIntegration.changeSuburb($btn.closest('.product-details__variant'));
                    });
                    */
                }
            }
        },
        filter: function (e) {
            var _$filter = $(e.target),
                _variants = $('.product-details__selection').not('.product-details__quantity'),
                _$variantOption = _$filter.parents('.product-details__selection'),
                _variantOption = _$variantOption.data('id'),
                _$nextItem = _$variantOption.next(),
                _nextFilter = _$nextItem.data('id'),
                _noMoreFilters = _$nextItem.hasClass('product-details__quantity'),
                _selectOptions = [],
                _variantVal;

            if (_variantOption === 'Colour') {
                var _variantOptionUl = _$variantOption.find('ul:first-child');
                if (_variantOptionUl.length > 0) {
                    if (_variantOptionUl.hasClass('disabled')) {
                        return;
                    }
                }
            }

            // Clear previous selections
            window.selectedVariants = [];
            window.selectedSkus = [];

            // Reset form components
            if(this.numerictextbox) {
                this.numerictextbox.enable(false);
                this.numerictextbox.value(1);
            }

            Core.AddToQuote.Cache.$groupPrice.hide();
            Core.AddToQuote.Cache.$groupCode.hide();

            Core.ProductDetail.Cache.$selectedVariantTitle.html(Core.ProductDetail.Cache.$productTitle);
            Core.ProductDetail.Cache.$selectedVariantPrice.text(Core.ProductDetail.Cache.$productPrice);
            if (Core.ProductDetail.Cache.$productPrice !== Core.ProductDetail.Cache.$productListPrice) {
                Core.ProductDetail.Cache.$selectedVariantListPrice.text(Core.ProductDetail.Cache.$productListPrice);
            } else {
                Core.ProductDetail.Cache.$selectedVariantListPrice.text('');
            }

            Core.ProductDetail.Cache.$selectedVariantCartBtn.addClass('disabled');
            Core.ProductDetail.Cache.$selectedVariantCompareBtn.addClass('disabled');
            Core.ProductDetail.Cache.$selectedVariantCartBtn.data('id', '');
            Core.ProductDetail.Cache.$selectedVariantCartBtn.data('price', '');

            $('.product-details__variant').removeClass('selected');
            $('.product-details__variant--cart').removeClass('added');
            if (selectedVariants.length === 0) {
                $(Core.AddToQuote.Cache.addToQuoteSelector).add(Core.AddToQuote.Cache.$rentBtn).add(Core.AddToQuote.Cache.$trialBtn).addClass('disabled');
            } else {
                $(Core.AddToQuote.Cache.addToQuoteSelector).add(Core.AddToQuote.Cache.$rentBtn).add(Core.AddToQuote.Cache.$trialBtn).removeClass('disabled');
            }

            //clear all filters after current filter
            if (!_noMoreFilters) {
                _$variantOption.nextAll().not('.product-details__quantity').each(function () {
                    var _$option = $(this),
                        _$dropdown = _$option.find('select'),
                        _$colours = _$option.find('ul');

                    // clear dropdowns
                    if (_$dropdown.length > 0) {
                        if (Core.HasKendoDropdowns()) {
                            _$dropdown.data("kendoDropDownList").enable(false);
                            var _dataSource = _$dropdown.data("kendoDropDownList").dataSource.data([]);
                            _dataSource = _$dropdown.data("kendoDropDownList").dataSource.add({
                                "text": 'Select ' + _$option.data('id'),
                                "value": 0
                            });
                            _$dropdown.data("kendoDropDownList").select(0);
                            _$dropdown.data("kendoDropDownList").trigger("change");
                        } else {
                            _$dropdown.prop('disabled', 'disabled');
                            _$dropdown.children().remove();
                            _$dropdown.append('<option value="0">Select ' + _$option.data('id') + '</option>');
                        }
                    }

                    // clear colour selection
                    if (_$colours.length > 0) {
                        _$colours.addClass('disabled');
                        _$colours.find('img').show();
                        _$colours.find('img.selected').removeClass('selected');
                    }
                    _$option.data('value', '');

                });
            }

            // if colour store value against variant
            if (_variantOption === 'Colour') {
                _$variantOption.data('value', _$filter.data('code').toLowerCase());
            }

            //store all selected attributes
            var _selectedAttributes = [];
            _variants.each(function () {
                var _$variant = $(this),
                    _variantOption = _$variant.data('id'),
                    _variantVal;

                if (_variantOption === 'Colour') {
                    if (_$variant.data('value')) {
                        _variantVal = _$variant.data('value').toLowerCase();
                    } else {
                        _variantVal = '0';
                    }
                }
                else {
                    _variantVal = _$variant.find('select').val().toLowerCase();
                }

                if (_variantVal !== '0') {
                    _selectedAttributes.push(_variantVal);
                }
            });

            var _currentSelectedOption = _$filter.find('option:selected'),
                _currentSelectedOptionValue = "0";
            if (_variantOption === 'Colour') {
                _currentSelectedOptionValue = _$variantOption.data('value');
            } else if (_currentSelectedOption.length > 0) {
                _currentSelectedOptionValue = _currentSelectedOption.val();
            }

            if (_currentSelectedOptionValue !== "0") {

                var _$dropdown = _$nextItem.find('select'),
                    _$colours = _$nextItem.find('ul'),
                    _$allColours = _variants.find('ul');

                function isInArray(value, array) {
                    return array.indexOf(value) > -1;
                }

                var minSalePrice = 0;
                var maxSalePrice = 0;
                var minListPrice = 0;
                var maxListPrice = 0;

                if (!_noMoreFilters) {
                    _$allColours.find('img').hide();
                }

                //add active skus and generate option items for next filter
                for (var i = 0; i < jsonResult.length; i++) {
                    var sku = jsonResult[i];

                    //check sku attributes matches chosen values
                    var _activeSku = true;
                    for (var x = 0; x < _selectedAttributes.length; x++) {
                        if (sku.Attributes) {
                            if (sku.Attributes[Object.keys(sku.Attributes)[x]].toLowerCase() !== _selectedAttributes[x]) {
                                _activeSku = false;
                                break;
                            }
                        }
                    }

                    if (_activeSku) {
                        window.selectedSkus.push(sku);

                        if (!_noMoreFilters) {
                            //generate dropdownlist for next filter
                            if (sku.Attributes) {
                                if (!isInArray(sku.Attributes[_nextFilter], _selectOptions)) {
                                    var _attribute = sku.Attributes[_nextFilter];
                                    _selectOptions.push(_attribute);

                                    if (_$dropdown.length > 0) {
                                        if (Core.HasKendoDropdowns()) {
                                            var dataSource = _$dropdown.data("kendoDropDownList").dataSource.add({
                                                "text": _attribute,
                                                "value": _attribute
                                            });
                                        } else {
                                            _$dropdown.append('<option value="' + _attribute + '">' + _attribute + '</option>');
                                        }
                                    }
                                }

                                var _attributeColour = sku.Attributes["Colour"];
                                if (_attributeColour && _$allColours.length > 0 && _attributeColour.length > 0) {
                                    var _img = _$allColours.find('img[data-code="' + _attributeColour + '"]');
                                    if (_img.length > 0) {
                                        _img.show();
                                    }
                                }
                            }

                            if (sku.SalePrice !== Core.Config.POA.Text) {
                                var salePrice = Number(sku.SalePrice.replace(/[^0-9\.]+/g, ""));
                                if (minSalePrice == 0 || salePrice < minSalePrice) {
                                    minSalePrice = salePrice;
                                }
                                if (salePrice > maxSalePrice) {
                                    maxSalePrice = salePrice;
                                }
                            }

                            if (sku.ListPrice !== Core.Config.POA.Text) {
                                var listPrice = Number(sku.ListPrice.replace(/[^0-9\.]+/g, ""));
                                if (minListPrice == 0 || listPrice < minListPrice) {
                                    minListPrice = listPrice;
                                }
                                if (listPrice > maxListPrice) {
                                    maxListPrice = listPrice;
                                }
                            }
                        } else {
                            // no more filters, so enable qty and add variant if only 1 exists
                            if (window.selectedSkus.length === 1) {
                                //this.numerictextbox.enable(true);

                                Core.ProductDetail.Cache.$selectedVariantTitle.html('<span>' + window.selectedSkus[0].Name + '<em>' + window.selectedSkus[0].Code + '</em></span>');
                                Core.ProductDetail.Cache.$selectedVariantPrice.text(window.selectedSkus[0].SalePrice);
                                if (window.selectedSkus[0].SalePrice !== window.selectedSkus[0].ListPrice) {
                                    Core.ProductDetail.Cache.$selectedVariantListPrice.text(window.selectedSkus[0].ListPrice);
                                } else {
                                    Core.ProductDetail.Cache.$selectedVariantListPrice.text('');
                                }
                                Core.ProductDetail.Cache.$selectedVariantCartBtn.removeClass('disabled');
                                Core.ProductDetail.Cache.$selectedVariantCartBtn.show();
                                Core.ProductDetail.Cache.$selectedVariantCompareBtn.removeClass('disabled');
                                Core.ProductDetail.Cache.$selectedVariantCartBtn.data('id', window.selectedSkus[0].Code);
                                Core.ProductDetail.Cache.$selectedVariantCartBtn.data('price', window.selectedSkus[0].Price);

                                this.renderProductDetail(window.selectedSkus[0]);

                                Core.ProductDetail.Cache.$selectedVariantCartBtn.trigger("click");
                            }
                        }
                    }
                }

                if (!_noMoreFilters) {
                    //alert("MINS: " + minSalePrice + " MAXS" + maxSalePrice + "MINL: " + minListPrice + " MAXL" + maxListPrice);
                    var newSalePrice = "$" + minSalePrice.toFixed(2);
                    if (minSalePrice == 0) {
                        newSalePrice = Core.Config.POA.Text;
                    }
                    if (minSalePrice != maxSalePrice && maxSalePrice > 0) {
                        newSalePrice = newSalePrice + " - " + "$" + maxSalePrice.toFixed(2);
                    }
                    Core.ProductDetail.Cache.$selectedVariantPrice.text(newSalePrice);

                    var newListPrice = "$" + minListPrice.toFixed(2);
                    if (minListPrice == 0) {
                        newListPrice = Core.Config.POA.Text;
                    }
                    if (minListPrice != maxListPrice && maxListPrice > 0) {
                        newListPrice = newListPrice + " - " + "$" + maxListPrice.toFixed(2);
                    }
                    if (newSalePrice !== newListPrice) {
                        Core.ProductDetail.Cache.$selectedVariantListPrice.text(newListPrice);
                    } else {
                        Core.ProductDetail.Cache.$selectedVariantListPrice.text('');
                    }

                    if (_$dropdown.length > 0) {
                        if (Core.HasKendoDropdowns()) {
                            _$dropdown.data("kendoDropDownList").enable(true);
                        } else {
                            _$dropdown.prop('disabled', false);
                        }
                    }

                    if (_$colours.length > 0) {
                        _$colours.removeClass('disabled');
                    }
                }
            } else {
                $('#complexVariant').html('');
            }

            //reset select options
            _selectOptions = [];
        }
    },
    gallery: {
        init: function () {
            if (Core.ProductDetail.Cache.$galleryThumbs.children().length > 1) {
                //render thumbnails
                Core.ProductDetail.Cache.$galleryThumbs.bxSlider(Core.ProductDetail.Cache.gallerySettings).css('visibility', 'visible');

                //thumbnail click event
                Core.ProductDetail.Cache.$galleryThumbs.find('span').on('click', $.proxy(this.thumbnailClick, this));
            } else {
              // hide thumbnails wrapper div
              Core.ProductDetail.Cache.$galleryThumbs.addClass('hidden');
            }

            if (!Core.IsMobile()) {
                //image zoom
                // Core.ProductDetail.Cache.$productZoom.on('mouseover', $.proxy(this.zoom, this));
            }
            else {
                //main image slide
                this.mobileGallery();
            }
        },

        thumbnailClick: function (e) {
            e.preventDefault();

            Core.Cache.$body.children('.zoomContainer').remove();

            var _$thumb = $(e.target).parent();
            _$thumb.addClass('active').parent().siblings().children().removeClass('active');

            Core.ProductDetail.Cache.$mainImg
    				.find('img.main-image')
            .attr('src', _$thumb.data('mainimg'))
            .data('zoom-image', _$thumb.data('zoom-image'));

            /*if (_$thumb.data('zoom-image') === '') {
                Core.ProductDetail.Cache.$mainImg.find('button#product-zoom').hide();
                Core.Cache.$body.children('.zoomContainer').remove();
            } else {
                Core.ProductDetail.Cache.$mainImg.find('button#product-zoom').show();
                this.zoom();
            }*/

        },

		// Handle product Zoom
        /*zoom: function () {
            $('.main-image').elevateZoom({
                zoomType : "inner",
                zoomWindowFadeIn: 300,
                zoomWindowFadeOut: 300
            });
        },*/
        mobileGallery: function () {
            var $mainImage = Core.ProductDetail.Cache.$mainImg.children('img');

            function scrollGallery($current, direction) {
                var _$images = Core.ProductDetail.Cache.$galleryThumbs.find('li');

                $current.find('span').removeClass('active');

                var currentIndex = _$images.index($current);
                currentZoomIndex = currentIndex;

                var _$next;
                if (direction === 'next') {
                    _$next = $current.next();

                    if (currentIndex == (_$images.length - 1)) {
                        _$next = _$images.first();
                    }
                }
                else {
                    _$next = $current.prev();

                    if (currentIndex === 0) {
                        _$next = _$images.last();
                    }
                }

                loadNextImage(_$next);
            }

            function loadNextImage($next) {
                var _$span = $next.find('span');
                _$span.addClass('active');

                $mainImage.on('load', function () {
                }).attr('src', _$span.data('mainimg'));
            }

            $mainImage.touchwipe({
                wipeLeft: function () {
                    scrollGallery(Core.ProductDetail.Cache.$galleryThumbs.find("span.active").parent(), 'next');
                },
                wipeRight: function () {
                    scrollGallery(Core.ProductDetail.Cache.$galleryThumbs.find("span.active").parent(), 'previous');
                },
                preventDefaultEvents: false
            });

            if (Core.ProductDetail.Cache.$galleryThumbs.children().length < 2) {
                Core.ProductDetail.Cache.$mainImg.addClass('single-image');
            } else {
                $('.mobile-gallery-btn.btn-prev').on('click', function () {
                    scrollGallery(Core.ProductDetail.Cache.$galleryThumbs.find("span.active").parent(), 'previous');
                });
                $('.mobile-gallery-btn.btn-next').on('click', function () {
                    scrollGallery(Core.ProductDetail.Cache.$galleryThumbs.find("span.active").parent(), 'next');
                });
            }
        },
    },
    trial: function () {

        Core.ProductDetail.Cache.$trialButton.on('click', function (e) {
            Core.ProductDetail.addProductsToFormField(e, Core.ProductDetail.Cache.$trialButton, Core.ProductDetail.Cache.$trialForm, Core.ProductDetail.Cache.$rentButton, Core.ProductDetail.Cache.$rentalForm);
        });

        Core.ProductDetail.Cache.$trialForm.on('submit', function (e) {
            Core.ProductDetail.formPost(e, Core.ProductDetail.Cache.$trialForm);
        });

        if (Core.GetParameterByName('trial')) {
            var code = Core.GetParameterByName('code');
            if (code.length > 0) {
                $('span.product-details__variant--cart[data-id="' + code + '"]').trigger("click");
                Core.ProductDetail.Cache.$trialButton.trigger("click");
            }
            Core.Cache.$body.add(Core.Cache.$html).animate({
                scrollTop: $('.product-details__btn-group--price').offset().top
            }, 2000);
        }
    },
    rent: function () {

        Core.ProductDetail.Cache.$rentButton.on('click', function (e) {
            Core.ProductDetail.addProductsToFormField(e, Core.ProductDetail.Cache.$rentButton, Core.ProductDetail.Cache.$rentalForm, Core.ProductDetail.Cache.$trialButton, Core.ProductDetail.Cache.$trialForm);
        });

        Core.ProductDetail.Cache.$rentalForm.on('submit', function (e) {
            Core.ProductDetail.formPost(e, Core.ProductDetail.Cache.$rentalForm);
        });

        if (Core.GetParameterByName('rent')) {
            var code = Core.GetParameterByName('code');
            if (code.length > 0) {
                $('span.product-details__variant--cart[data-id="' + code + '"]').trigger("click");
                Core.ProductDetail.Cache.$rentButton.trigger("click");
            }
            Core.Cache.$body.add(Core.Cache.$html).animate({
                scrollTop: $('.product-details__btn-group--price').offset().top
            }, 2000);
        }
    },
    addProductsToFormField: function (e, $btn, $form, $otherBtn, $otherForm) {
        if (!$btn.hasClass('disabled')) {
            var _productCode = $('span.added');
            var $btnParent = $btn.closest('.product-details__btn-group');

            var blkstr = [];
            $.each(_productCode, function (i, e) {
                var str = $(e).data('id');
                blkstr.push(str);
            });

            $form.show().find('.productCode').val(blkstr.join(","));
            Core.ProductDetail.closeFormField($otherForm);

            $btn.addClass('selected');
            $otherBtn.removeClass('selected');

            Core.Cache.$body.add(Core.Cache.$html).animate({
                scrollTop: $btnParent.offset().top - 15
            }, 500);
        }
        else {
            e.preventDefault();
        }
    },
    closeFormField: function ($form) {
        $form.hide();
    },
    formPost: function (e, $form) {

        e.preventDefault();

        var _$validationMessage = $form.find('.frm-validation-msg');
        _$validationMessage.html("");

        var _$isRentalForm = $form.attr('action').indexOf('rent') !== -1;

        var _$validator = $form.validate({
            focusInvalid: false,
            invalidHandler: function (form, validator) {

                if (!validator.numberOfInvalids())
                    return;

                $('html, body').animate({
                    scrollTop: $(validator.errorList[0].element.parentElement).offset().top - 30
                }, 300);

            }
        });

        if ($form.valid()) {

            Core.ShowPageLoading();

            if (selectedVariants.length > 0) {
                var _$productData = JSON.stringify(selectedVariants);
                if (_$isRentalForm) {
                    Core.ProductDetail.Cache.$rentalForm.find('.productCode').val(_$productData);
                } else {
                    Core.ProductDetail.Cache.$trialForm.find('.productCode').val(_$productData);
                }
            }

            $.ajax({
                url: $form.attr('action'),
                data: $form.serialize(),
                type: 'POST',
                dataType: 'json',
                success: function(data) {
                    Core.HidePageLoading();
                    var _$validationMessage = $form.find('.frm-validation-msg');
                    _$validationMessage.hide();
                    if (data.Success) {
                        $form.hide();
                        var _width = Core.Config.CartNotification.Width,
                            _height = Core.Config.CartNotification.Height;

                        if (Core.IsMobile()) {
                            _width = Core.Cache.$window.width();
                        }

                        var _$confirmationWindow = Core.ProductDetail.Cache.$confirmationWindow.kendoWindow({
                            width: _width,
                            height: _height,
                            visible: false,
                            iframe: false,
                            modal: true,
                            resizable: false,
                            pinned: true,
                            draggable: false,
                            appendTo: '#page-wrap'
                        });

                        var _$regLink = _$confirmationWindow.find("a.register");
                        if (_$regLink.length > 0) {
                            var _$href = _$regLink.attr("href");
                            _$regLink.attr("href", _$href + "?quoteid=" + data.QuoteId);
                        }

                        _$confirmationWindow.data("kendoWindow").center().open();

                        $(".k-overlay").on('click', function() {
                            window.location.href = window.location.href;
                        });

                        $(".k-window-action > span.k-i-close, .cart-notification-buttons > a.k-i-close").on('click', function (e) {
                            window.location.href = window.location.href;
                        });

                    } else {
                        _$validationMessage.html('<div class="error-msg">' + data.ErrorMessage + '</div>').show();
                        Core.Cache.$body.add(Core.Cache.$html).animate({
                            scrollTop: _$validationMessage.offset().top - 40
                        }, 500);
                    }
                },
                error: function(xhr, ajaxOptions, thrownError) {
                    //todo: do something
                }
            });
        } else {
            _$validator.focusInvalid();
        }
    },
    scrollToTabs: function () {
        Core.ProductDetail.Cache.$scrollToTabs.on('click', function (e) {
            e.preventDefault();
            var _$this = $(this),
                _$tab = $('.product-extras__tab a[data-check-name="' + _$this.data("check-name") + '"]');

            if (!_$tab.hasClass('active')) {
                _$tab.trigger('click');
            }

            Core.Cache.$body.add(Core.Cache.$html).animate({
                scrollTop: _$tab.offset().top
            }, 1000);
        });
    },
    favourites: function () {
        var _self = Core.ProductDetail;

        _self.Cache.$favouriteBtn.on('click', function (e) {
            Core.ShowPageLoading();

            var $this = $(this),
                _stateRemove = $this.hasClass('active'),
                _apiUrl = _stateRemove ? '/cart/removefromfavourites' : '/cart/addtofavourites',
                $errorBox = $('#product-detail .portal-error');

            $.ajax({
                url: _apiUrl,
                data: {
                    code: _self.Cache.$favouriteBtn.data('id')
                },
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    //console.log(data);
                    if(data.WasSuccess) {
                        if (_stateRemove) {
                            $this.attr('title', Core.Config.FavouriteText.Add).text(Core.Config.FavouriteText.Add);
                        } else {
                            $this.attr('title', Core.Config.FavouriteText.Remove).text(Core.Config.FavouriteText.Remove);
                        }
                        Core.ShowErrorMessage($errorBox, null, false);
                        _self.Cache.$favouriteBtn.toggleClass('active');
                    } else {
                        Core.ShowErrorMessage($errorBox, {
                            title: Core.Config.FavouriteText.ErrorTitle,
                            message: data.Result
                        });
                    }

                    Core.HidePageLoading();
                },
                error: function (xhr, status, error) {
                    Core.ShowErrorMessage($errorBox, {
                        title: Core.Config.FavouriteText.ErrorTitle,
                        message: [
                            xhr.responseText,
                            "Status: " + xhr.status,
                            "Error: " + error
                        ]
                    });
                    Core.HidePageLoading();
                }
            });

            e.preventDefault();
        });
    },
    viewMore: function() {
        var productDescription = $('.product-details__description');
        var productDescriptionClass = $('.product-details__description.less');
        var descHeight = 240;

        if (productDescription.height() < descHeight) {
            $('.showLessMore').hide();
        } else {
            productDescriptionClass.css('height', descHeight + 'px');
        }

        $('.showLessMore a:first').on('click', function (e) {
            e.preventDefault();


            if (productDescription.hasClass('less')) {
                productDescription.removeClass('less');
                productDescriptionClass.css('height', 'inherit');
                $(e.target).text('Show less');
                $(e.target).attr('title', 'less');
            } else {
                productDescription.addClass('less');
                productDescriptionClass.css('height', descHeight + 'px');
                $(e.target).text('Show more');
                $(e.target).attr('title', 'more');
                if (Core.IsMobile()) {
                    Core.Cache.$body.add(Core.Cache.$html).animate({
                        scrollTop: $('.product-detail__title').offset().top - 20
                    }, 1000);
                }
            }
        });
    },

    arrangeLayout: function () {
        //check if mobile
        var $desc = $('.product-details__column-description')
            , $trial = $('.product-details__column-availability');

        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        //check tablet
        if (width >= 600 && width < Core.Config.TabletWidth) {
            $desc.prependTo('.product-details__columnwrap');
            $trial.appendTo('.product-details__column-left');
        } else {
            //desktop and small mobile (less than 600px) /
            $desc.prependTo('.product-details__column-left');
            $trial.appendTo('.product-details__column-right');
        }
    },
    updateVariantQuantity: function() {
        //copy from above. this should be a global function since it's using more than place
        if (this.value() === null) {
            this.value(1);
        }

        var _$groupPrice = $('#groupPrice');
        var _sku = window.selectedSkus[0].Code,
            _qty = this.value(),
            _groupPrice = 0;

        for (var i = 0; i < window.selectedVariants.length; i++) {
            if (window.selectedVariants[i]['sku'] == _sku) {
                window.selectedVariants[i].qty = _qty;
                break;
            }
        }

        for (var x = 0; x < selectedVariants.length; x++) {
            _groupPrice += parseFloat(selectedVariants[x].price * selectedVariants[x].qty);
        }

        if (_groupPrice === 0) {
            _$groupPrice.text(Core.Config.POA.Text).show();
        }
        else {
            _$groupPrice.text('$' + _groupPrice.toFixed(2)).show();
        }
    },

    setProductDetailHeight: function() {
        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (width >= Core.Config.MobileWidth && width <= Core.Config.TabletWidth) {
            var h = $('.product-details__gallery-wrap').height();
            $('.product-details__block-details').css('height', h + 20 + "px");
        } else {
            $('.product-details__block-details').css('height', '');
        }

    },
    isDVA: function() {
      var isDVA = $(`#isDVA`).val() || '';
      return (isDVA.toString() === 'true');
    },
};
